<template>
    <div class="row align-items-center px-5 pb-5">
        <div class="col-12">
            <span class="icon icon-sm rounded-circle bg-success-light"><i class="text-success material-icons md-done"></i> </span> 
            <span class="h5"> Consigment Complete!</span>
        </div>
        <div class="col-12 mt-5">
            <a href="#." class="btn badge-soft-secondary btn-block mr-2 text-secondary" @click="generateReport"> 
                <i class="text-secondary material-icons md-receipt"></i> Invoice
            </a>

            <a href="#." class="btn  btn-block badge-soft-warning text-warning border-0" @click="generateConsigmentReport"> 
                <i class="text-warning material-icons md-print"></i> Print
            </a>  
        </div>

        <div>
            <vue-html2pdf
                :show-layout="false"
                :float-layout="true"
                :enable-download="true"
                :preview-modal="true"
                :paginate-elements-by-height="25000"
                :filename="new Date().getTime() + 'invoice'"
                :pdf-quality="1"
                :manual-pagination="false"
                pdf-format="legal"
                pdf-orientation="portrait"
                pdf-content-width="98%"
                
                @progress="onProgress($event)"
                @hasStartedGeneration="hasStartedGeneration()"
                @hasGenerated="hasGenerated($event)"
                ref="html2Pdf"
            >
                <section slot="pdf-content">
                    <!-- PDF Content Here -->
                    <template v-if="consognment">
                        <invoice :consognment="consognment"></invoice>
                    </template>
                </section>
            </vue-html2pdf>
        </div>

        <div class="mb-5">
            <vue-html2pdf
                :show-layout="false"
                :float-layout="true"
                :enable-download="true"
                :preview-modal="true"
                :paginate-elements-by-height="1100"
                :filename="new Date().getTime() + 'consigment'"
                :pdf-quality="2"
                :manual-pagination="true"
                pdf-format="a4"
                pdf-orientation="landscape"
                pdf-content-width="98%"
        
                @progress="onProgress($event)"
                @hasStartedGeneration="hasStartedGeneration()"
                @hasGenerated="hasGenerated($event)"
                ref="html2PdfConsigment"
            >
                <section slot="pdf-content">
                    <consigmentPDf :consognment="consognment"></consigmentPDf>
                </section>
            </vue-html2pdf>
        </div>
        <!-- <consigmentPDf :consognment="consognment"></consigmentPDf> -->
        <!-- <template v-if="consognment">
            <invoice :consognment="consognment"></invoice>
        </template> -->
    </div> 
</template>

<script>
import invoice from "./Invoice";
import consigmentPDf from "./ConsigmentPDF.vue";

export default {
    props: ["consognment"],
    data() {
        return {
            
        };
    },
    components: {
        invoice,
        consigmentPDf
    },
    methods: {
        generateReport() {
            this.$refs.html2Pdf.generatePdf();
        },
        generateConsigmentReport() {
            this.$refs.html2PdfConsigment.generatePdf();
        },
    },
    mounted() {
        
    },

}
</script>